import React from "react";

interface HomeIconProps {
  className?: string;
  color?: string;
}

export const HomeIcon: React.FC<HomeIconProps> = ({
  className = "",
  color = "currentColor",
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
    >
      {/* 房子主体 */}
      <path
        d="M12 2.5L2.5 10.5V21.5H9V14.5H15V21.5H21.5V10.5L12 2.5Z"
        fill={color}
      />
      {/* 烟囱 */}
      <rect x="16" y="4" width="3" height="5" rx="0.5" fill={color} />
    </svg>
  );
};

export default HomeIcon;
